import { useTranslation } from 'react-i18next';

export default function About() {
  const { i18n } = useTranslation();

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-center">
          {/* Left Content */}
          <div className="md:col-span-3">
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-diamond-line text-2xl text-[#D4AF37]"></i>
              <span className="text-sm font-medium text-[#1A5F7A] uppercase tracking-wider">
                {i18n.language === 'ar' ? 'عن كيمبرلايت' : 'About Kimberlite'}
              </span>
            </div>

            <h2 className="text-5xl font-bold mb-6">
              <div className="text-[#0A2647]">
                {i18n.language === 'ar' ? 'شريكك الاستراتيجي' : 'Your Strategic Partner'}
              </div>
              <div className="bg-gradient-to-r from-[#1A5F7A] to-[#D4AF37] bg-clip-text text-transparent">
                {i18n.language === 'ar' ? 'في التجارة العالمية' : 'in Global Commerce'}
              </div>
            </h2>

            <div className="space-y-6 text-lg text-[#3D3D3D] leading-relaxed">
              <p>
                {i18n.language === 'ar'
                  ? 'كيمبرلايت للوساطة التجارية هي شركة متخصصة مقرها قطر في الوساطة التجارية، تعمل كجسر استراتيجي بين منطقة الشرق الأوسط وشمال أفريقيا والسوق العالمية.'
                  : 'Kimberlite Commercial Brokerage is a Qatar-based specialist in commercial brokerage, acting as a strategic bridge between the MENA region and the global market.'}
              </p>
              <p>
                {i18n.language === 'ar'
                  ? 'مقرنا في الدوحة، نربط الطلب المحلي بالعرض العالمي، مما يضمن شروطًا تجارية مثالية من خلال الشفافية والتفاوض الخبير.'
                  : 'Based in Doha, we connect local demand with global supply, ensuring optimal commercial terms through transparency and expert negotiation.'}
              </p>
              <p>
                {i18n.language === 'ar'
                  ? 'خبرتنا العميقة في منطقة الشرق الأوسط وشمال أفريقيا، جنبًا إلى جنب مع شبكتنا الدولية الواسعة، تجعلنا الشريك المثالي للشركات التي تسعى للتوسع في أسواق جديدة أو تأمين سلاسل توريد موثوقة.'
                  : 'Our deep expertise in the MENA region, combined with our extensive international network, makes us the ideal partner for businesses seeking to expand into new markets or secure reliable supply chains.'}
              </p>
            </div>

            <a
              href="#contact"
              className="inline-flex items-center gap-2 mt-8 text-[#1A5F7A] font-medium hover:text-[#D4AF37] transition-colors cursor-pointer group"
            >
              {i18n.language === 'ar' ? 'اكتشف قصتنا' : 'Discover Our Story'}
              <i className={`ri-arrow-${i18n.language === 'ar' ? 'left' : 'right'}-line group-hover:translate-x-1 transition-transform`}></i>
            </a>
          </div>

          {/* Right Visual */}
          <div className="md:col-span-2 relative">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/08dc43c36154426f5d8d89d7d18c5793.jpg"
                  alt="Doha Port"
                  className="w-full h-[500px] object-cover object-top"
                />
              </div>

              <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-xl p-6 border-2 border-[#D4AF37] max-w-[200px]">
                <div className="text-4xl font-bold text-[#0A2647] mb-1">150+</div>
                <div className="text-sm text-gray-600">
                  {i18n.language === 'ar' ? 'شريك دولي' : 'International Partners'}
                </div>
              </div>
            </div>

            <div className="absolute -top-8 -right-8 bg-white rounded-2xl shadow-xl p-6 border-2 border-[#1A5F7A] max-w-[180px]">
              <div className="text-4xl font-bold text-[#0A2647] mb-1">25+</div>
              <div className="text-sm text-gray-600">
                {i18n.language === 'ar' ? 'دولة مخدومة' : 'Countries Served'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
